var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"qrcode-app"},[_c('div',{staticClass:"qrcode-container"},[(_vm.qrcodeLink)?_c('img',{staticStyle:{"width":"100vw"},attrs:{"src":_vm.qrcodeLink}}):_c('img',{attrs:{"src":_vm.defaultLink}})])])}
var staticRenderFns = []

export { render, staticRenderFns }